import { render, staticRenderFns } from "./NumbersRate.vue?vue&type=template&id=8ce116aa&"
import script from "./NumbersRate.vue?vue&type=script&lang=js&"
export * from "./NumbersRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports